module.exports = __webpack_public_path__ + "media/images/games/35gender/housekeeper-404c4d343abbc1f27e0c23ff2f410464.png";